import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import '../styles/_tierTable.scss';

// NOTE: you cannot actually edit a tier with PayPal despite documentation. Any "disabled" tiers are hiddenn from the table.

const TierTable = ({ tiers, loading, dataError, memberships, /* onEditTier, onEnableTier, */ onDisableTier }) => {
  const [loadingWait, setLoadingWait] = useState(false);

  useEffect(() => {
    // show loading animation for at least 2 seconds
    setTimeout(function () {
      setLoadingWait(true)
    }, 2000);
  }, [])

  if (dataError !== '') {
    return (
      <p className="table-message">{ dataError }</p>
    )
  }

  if (!loading && tiers.length === 0) {
    return (
      <p className="table-message">{'No tiers created yet'}</p>
    )
  }

  return (
    <div className="tier-table">
      { (loading || !loadingWait) &&
        <Loading></Loading>
      }
      <table>      
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Cost</th>
            <th>Discounted Cost</th>
            <th>Subscriptions</th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {tiers && tiers.map((result, index) => {
            return (
              <tr key={'tier--' + index} className={`${index % 2 === 1 ? 'highlight' : ''}`}>
                <td>{result.name}</td>
                <td>{result.description}</td>
                <td>${result.cost}</td>
                <td>${result.discountedCost}</td>
                <td>{memberships[result.name] ? memberships[result.name].length : 0}</td>
                {/* <td>
                  {result.isOff &&
                    <>
                      <div style={{width: '46.44px', display: 'inline-block'}}></div>
                      <i className="fa fa-toggle-off" style={{color: 'red', fontSize: '25px'}} onClick={() => onEnableTier(result.id)}></i>
                    </>
                  }
                  {!result.isOff &&
                    <>
                      <i className="fa fa-pencil" style={{fontSize: '25px'}} onClick={() => onEditTier(result.id)}></i>
                      <i className="fa fa-toggle-on" style={{color: '#04b840', fontSize: '25px'}} onClick={() => onDisableTier(result.id)}></i>
                    </>
                  }
                </td> */}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default TierTable;